import ExportJsonExcel from 'js-export-excel';

class CauseOfMorbidityExcel {
    exportExcel(data) {
        let option = {};  // La opción representa el archivo de Excel
        let tenCorrectsData = this.revisarCuausaDeMorbilidad(data);
        option.fileName = 'Causa de Morbilidad';  // Nombre del archivo Excel
        option.datas = [
            {
                sheetData: tenCorrectsData.data,  // Fuente de datos en archivo Excel
                sheetName: 'Causa de Morbilidad',  // nombre de la página de hoja en el archivo de Excel
            }
        ]
        let toExcel = new ExportJsonExcel(option);  // Generar archivo de Excel
        toExcel.saveExcel();  // Descargar archivo de Excel
    }

    revisarCuausaDeMorbilidad(dataDetails) {
        let dataTable = [];

        //Titulos
        let CasillasTitulos = this.generarTitulos();
        dataTable.push(CasillasTitulos);

        //Admisiones
        for (let i = 0; i < dataDetails.length; i++) {
            let infoDetallada = this.generarInformacionDetallada(dataDetails[i]);
            dataTable.push(infoDetallada);
        }

        let sheet =
        {
            data: dataTable
        }

        return sheet;
    }

    generarTitulos() {
        let casillas = {
            '1': "CÓDIGO",
            '2': "NOMBRE",
            '3': "MUJERES",
            '4': "HOMBRES",
            '5': "TOTAL"
        }
        return casillas;
    }

    generarInformacionDetallada(data) {
        let casillas = {
            '1': data.codigo,
            '2': data.nombre,
            '3': data.mujeres,
            '4': data.hombres,
            '5': data.total
        }
        return casillas;
    }

}

export default new CauseOfMorbidityExcel();